import { render, staticRenderFns } from "./MultipleNote.vue?vue&type=template&id=9c61d8ae&scoped=true&"
import script from "./MultipleNote.vue?vue&type=script&lang=js&"
export * from "./MultipleNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c61d8ae",
  null
  
)

export default component.exports